import {useEffect} from 'react'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutAdminRole = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const request = (e, idx, type) => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest('PUT', `/${rolePath}/${idx}/role`, {
			role_type: type,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'admin_idx')
					setAlert('관리자 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'role_type')
					setAlert('권한 종류를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('관리자 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutAdminRole
